import { useQuery } from '@tanstack/react-query';

import { fetchStudentBulletinTutors } from '../api/routes';
import type { ChatRoomStatus, StudentBulletinTutorResponse } from '../api/routes';
import { isAccessibleChatRoomId } from '../utils/isAccessibleChat';

const isAccessibleTutor = (tutor: StudentBulletinTutorResponse): boolean =>
  tutor.chat_id != null && isAccessibleChatRoomId(tutor.room_id);

export const useStudentBulletinTutors = (
  bulletinId: number | null,
  chatStatus: ChatRoomStatus,
  enabled = true,
) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['student_bulletin_tutors', bulletinId, chatStatus],
    queryFn: () => fetchStudentBulletinTutors(bulletinId as number, chatStatus),
    staleTime: 30 * 1000,
    enabled: enabled && bulletinId != null,
  });

  return {
    tutors: (data ?? []).filter(isAccessibleTutor),
    isLoading,
    refetch,
  };
};
